import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import {withQuery, withMutation} from '../../../../shared/enhancers/graphql-enhancer.js';
import {tool} from '../../../../data/tool-profile/queries.js';
import AlternateDecisions from '../../../../shared/library/cards/alternate-decision';
import {compose} from 'react-apollo';
import {trackViews} from '../../../../data/shared/mutations.js';
import Circular, {LARGE} from '../../../../shared/library/indicators/indeterminate/circular';
import {flattenEdges} from '../../../../shared/utils/graphql.js';
import withErrorBoundary from '../../../../shared/enhancers/error-boundary';
import {callTrackViews} from '../../../../../app/shared/utils/trackViews.js';

const Container = glamorous.div({
  margin: '20px auto'
});

const Spinner = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  margin: '100px 0'
});

const sendTrackViewsMutation = ({loading, decisions, trackViews}) => {
  if (!loading && decisions.stackDecisions.edges.length !== 0) {
    const decisionIds = [];
    decisions.stackDecisions.edges.map(d => decisionIds.push(d.node.id));
    callTrackViews({
      trackViews,
      decisionIds,
      clientContext: `ToolProfileDecisions-${window.location.pathname}`
    });
  }
};

const ToolProfileDecisions = ({loading, decisions, trackViews}) => {
  useEffect(() => {
    sendTrackViewsMutation({loading, decisions, trackViews});
  }, [decisions]);

  if (loading) {
    return (
      <Spinner>
        <Circular size={LARGE} />
      </Spinner>
    );
  }
  if (decisions) {
    const items = flattenEdges(decisions.stackDecisions);
    return (
      <Container>
        <AlternateDecisions decisions={items} />
      </Container>
    );
  }
  return null;
};

ToolProfileDecisions.propTypes = {
  loading: PropTypes.bool,
  decisions: PropTypes.object,
  trackViews: PropTypes.func
};

export default compose(
  withQuery(tool, data => ({
    decisions: data.tool,
    loading: data.loading
  })),
  withMutation(trackViews, mutate => ({
    trackViews: (decisionIds, clientContext) => mutate({variables: {decisionIds, clientContext}})
  })),
  withErrorBoundary(true)
)(ToolProfileDecisions);
